export default "__VITE_ASSET__DnL58m$a__"